import appEnvironment from "./environment";

/**
 * User IDs from the active entry in `config/environment/*.ts` (via `APP_ENV`).
 * Empty: no id restriction (chat uses API roles only). Non-empty: id-only allowlist.
 */
export function getChatAssistantAllowedUserIds(): number[] {
  return appEnvironment.chatAssistantAllowedUserIds;
}
